import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { TaxedPrice } from '@/components/TaxedPrice';
import { Typography } from '@/components/Typography';

import { ReactComponent as DeleteSVG } from '@/assets/icons/delete.svg';
import { ReactComponent as PlusSVG } from '@/assets/icons/plus.svg';

export const ImageWrapper = styled(Box)`
  position: relative;
  width: 96px;
  min-height: 96px;
`;

export const Sku = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.secondaryGrey};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const Name = styled(Typography)`
  text-transform: uppercase;
  padding-right: 25px;
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h5};
  `}
`;

export const AdditionalName = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.secondaryGrey};
  `}
`;

export const Price = styled(TaxedPrice)`
  ${({ theme }) => css`
    p {
      font-size: ${theme.fontSizes.h5};
      font-family: ${theme.fontFamilies.italianPlate};
    }
    padding-top: ${theme.spacing(1)};
  `}
`;

export const RowContent = styled(Flex)`
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  .strap-size-select {
    justify-content: space-between;
    margin: 0;
  }
`;

export const Image = styled(NextImage)<{ $scaleRatio?: number }>`
  object-fit: contain;
  width: 100%;
  height: auto;

  ${({ $scaleRatio }) => css`
    transform: scale(${$scaleRatio});
  `}
`;

export const DeleteButton = styled.button<{ isBuckle?: boolean }>`
  all: unset;
  cursor: pointer;
  transform: translateX(5px);
  position: absolute;
  top: 3px;
  right: 0;
  ${({ isBuckle }) =>
    isBuckle &&
    css`
      position: unset;
      transform: unset;
      height: fit-content;
    `}
`;

export const DeleteIcon = styled(DeleteSVG)`
  width: 24px;
  height: 24px;
  path:nth-child(2) {
    ${({ theme }) => css`
      fill: ${theme.colors.secondaryGrey};
    `}
  }
`;

export const PreOrderNote = styled(Typography)`
  width: 100%;
  text-align: right;
  color: ${({ theme }) => theme.colors.black};

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    padding-top: ${theme.spacing(1)};

    ${theme.media.md.down} {
      text-align: center;
    }
  `}
`;

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    & > button {
      border-bottom: 1px solid ${theme.colors.primaryAdd6};
    }

    ${theme.media.md.down} {
      margin-bottom: -${theme.spacing(2)};
      margin-inline: -${theme.spacing(2)};
    }
  `}
`;

export const AddButton = styled.button`
  width: 100%;
  display: flex;
  position: relative;
  padding: 0.5rem 1rem 0.5rem 1rem;

  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};

    ${theme.media.md.up} {
      background-color: ${theme.colors.white};
    }
  `}
`;

export const PlusIcon = styled(PlusSVG)`
  width: 24px;
  height: 24px;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const ButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.primaryBlue};
`;

export const ButtonImageWrapper = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  height: 41px;
  width: 86px;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      left: 150px;
    }
  `}
`;

export const WatchBox = styled(Box)`
  padding: 1rem 0;
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.primaryAdd6};
  `}
`;

export const BuckleWrapper = styled(Flex)`
  ${({ theme }) => css`
    padding: ${theme.spacing(1.5)};
    background-color: ${theme.colors.lightGrey};
    margin-bottom: ${theme.spacing(1)};
  `}
`;

export const BuckleName = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const BuckleImageWrapper = styled(Box)`
  position: relative;
  height: 48px;
  width: 48px;
  min-width: 48px;
`;

export const BuckleTreeView = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  ${({ theme }) => css`
    padding-left: ${theme.spacing(2)};
    > div {
      margin-bottom: ${theme.spacing(1)};
    }
  `}
`;

export const ItemWrapper = styled(Box)`
  flex: 1;
`;
